import { render, staticRenderFns } from "./WaitingListDetailsView.vue?vue&type=template&id=53eca2da&"
import script from "./WaitingListDetailsView.vue?vue&type=script&lang=js&"
export * from "./WaitingListDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports